import { Component, OnInit } from '@angular/core';
import {PlayersService} from "../../../services/players.service";

@Component({
  selector: 'app-player-stats-modal-content',
  templateUrl: './player-stats-modal-content.component.html',
  styleUrls: ['./player-stats-modal-content.component.scss']
})
export class PlayerStatsModalContentComponent implements OnInit {

  private _tableOfDetails;
  private _playerSummaryList;
  private _playerPhoto;
  private playerVideosOpened: boolean = false;

  constructor(private playersService: PlayersService) { }

  ngOnInit(): void {
    this.playersService.getPlayerStats().subscribe((response) => {
      this.tableOfDetails = response;
    });

    this.playersService.getPlayer(this.playersService.playerId).subscribe((response) => {
      this.playerSummaryList = response;
      this.playerPhoto = this.playerSummaryList?.image;
    });
  }

  get tableOfDetails() {
    return this._tableOfDetails;
  }

  set tableOfDetails(listOfObjects) {
    this._tableOfDetails = listOfObjects;
  }

  get playerSummaryList() {
    return this._playerSummaryList;
  }

  set playerSummaryList(object) {
    this._playerSummaryList = object;
  }

  get playerPhoto() {
    return this._playerPhoto;
  }

  set playerPhoto(photo) {
    this._playerPhoto = photo;
  }

  getPlayerFullName() {
    return this.playerSummaryList?.full_name;
  }

  setPlayerVideosOpened (): void {
    this.playerVideosOpened = !this.playerVideosOpened;
  }

  getPlayerVideosOpened () : boolean {
    return this.playerVideosOpened;
  }

}
